(() => {
  'use strict';
  const data = JSON.parse(document.getElementById('nd-commerce-data').textContent);
  const root = data.root || '/';
  let state = {qm:1,qk:1}, busy = false, uncertain = false;
  const forms = [...document.querySelectorAll('[data-nd-purchase]')];
  const money = cents => new Intl.NumberFormat(undefined,{style:'currency',currency:data.currency || 'USD'}).format(cents/100);
  const keys = key => key === 'both' ? ['m','k'] : [key];
  const quantity = key => state['q'+key];
  const sellable = (v,q) => !!v && v.available && (!v.tracked || v.policy !== 'deny' || v.stock >= q);
  function status(message, cartLink = false) {
    const el = document.getElementById('nd-status'); el.hidden = false; el.textContent = message;
    if(cartLink) { const a=document.createElement('a'); a.href=data.cartUrl; a.textContent=' View cart'; el.append(a); }
  }
  function render(s = state) {
    state = s;
    const price = {m:data.m?.price,k:data.k?.price,from:Math.min(...['m','k'].filter(k=>data[k]).map(k=>data[k].price)),m100:data.m?.weight>0 ? Math.round(data.m.price*100/data.m.weight) : NaN,k100:data.k?.weight>0 ? Math.round(data.k.price*100/data.k.weight) : NaN};
    document.querySelectorAll('[data-price]').forEach(el=>{const p=price[el.dataset.price]; el.textContent=Number.isFinite(p)?money(p):'Unavailable';});
    forms.forEach(form=>{
      const ks=keys(form.dataset.ndPurchase), btn=form.querySelector('button'), ok=ks.every(k=>sellable(data[k],quantity(k)));
      form.querySelectorAll('[data-quantity]').forEach(el=>{el.value=quantity(el.dataset.quantity);});
      btn.disabled=busy || uncertain || !ok;
      btn.textContent=busy?'Updating cart…':(!ok?'Unavailable for this quantity':btn.dataset.label+' · '+money(ks.reduce((t,k)=>t+data[k].price*quantity(k),0)));
    });
    document.querySelectorAll('[data-act]').forEach(btn=>{const a=btn.dataset.act,k=a.endsWith('M')?'m':'k';btn.disabled=busy || uncertain || (a.startsWith('dec') ? quantity(k)<=1 : quantity(k)>=12);});
  }
  window.ndCommerceRender=render;
  async function json(url, options={}) {
    const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options});
    let result; try {result=await response.json();} catch {throw new Error('Could not confirm the cart response.');}
    if(!response.ok) {const error=new Error(result.description || result.message || 'Shopify could not update the cart.'); error.confirmedRejection=response.status===422; throw error;}
    return result;
  }
  forms.forEach(form=>form.addEventListener('submit',async event=>{
    event.preventDefault(); if(busy || uncertain) return;
    const ks=keys(form.dataset.ndPurchase), captured=ks.map(k=>({k,id:data[k]?.id,quantity:quantity(k),price:data[k]?.price}));
    if(!captured.every(i=>sellable(data[i.k],i.quantity))) return;
    busy=true; render(); let mutationStarted=false;
    try {
      const before=await json(root+'cart.js');
      const fresh=await Promise.all(captured.map(async item=>{
        const product=await json(data[item.k].url+'.js');
        const v=product.variants.find(v=>String(v.id)===String(item.id));
        if(!v) {data[item.k].available=false; throw new Error('This coffee is unavailable.');}
        data[item.k].price=v.price; data[item.k].available=v.available;
        const existing=before.items.filter(i=>String(i.variant_id)===String(item.id)).reduce((n,i)=>n+i.quantity,0);
        if(!sellable(data[item.k],item.quantity+existing)) throw new Error('Not enough coffee available for this quantity, including bags already in your cart.');
        return {item,v};
      }));
      if(fresh.some(({item,v})=>item.price!==v.price)) throw new Error('The live price changed. Review the updated price and try again.');
      mutationStarted=true;
      await json(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:captured.map(({id,quantity})=>({id,quantity}))})});
      const after=await json(root+'cart.js');
      const count=(cart,id)=>cart.items.filter(i=>String(i.variant_id)===String(id)).reduce((n,i)=>n+i.quantity,0);
      if(!captured.every(i=>count(after,i.id)===count(before,i.id)+i.quantity) || !before.items.every(i=>after.items.some(j=>j.key===i.key && j.quantity>=i.quantity))) throw new Error('Please verify your cart before adding again.');
      status('Added to your cart.',true);
      if(form.dataset.action==='buy') window.location.assign(data.cartUrl);
    } catch(error) {
      if(mutationStarted && !error.confirmedRejection) uncertain=true;
      status(uncertain?'The cart update could not be confirmed. Check your cart before adding again.':error.message,true);
    } finally {busy=false;render();}
  }));
  render();
})();
